import { FC } from 'react';
import { FormattedMessage } from 'dibs-react-intl';
import classnames from 'classnames';

import { Button } from 'dibs-elements/exports/Button';

import dibsCss from 'dibs-css';

type Props = {
    display: boolean;
    backModal: () => void;
    closeModal: () => void;
};

const abandonButton = classnames(dibsCss.wFull, dibsCss.uppercase, dibsCss.mtMedium);

export const SellerApplicationAbandonConfirmation: FC<Props> = ({
    display,
    backModal,
    closeModal,
}) => {
    return (
        <div className={!display ? dibsCss.hidden : ''}>
            <div
                className={classnames(
                    dibsCss.wFull,
                    dibsCss.textCenter,
                    dibsCss.mbXsmall,
                    dibsCss.sassyFontBody
                )}
            >
                <FormattedMessage
                    id="SellerApplicationAbandonConfirmation.info"
                    defaultMessage="Are you sure you want to exit? Your changes will not be saved."
                />
            </div>
            <Button
                size="large"
                className={abandonButton}
                onClick={() => {
                    closeModal();
                }}
            >
                <FormattedMessage
                    id="SellerApplicationAbandonConfirmation.button.exit"
                    defaultMessage="Yes, Leave"
                />
            </Button>
            <Button
                size="large"
                type="secondary"
                className={classnames(abandonButton, dibsCss.mtSmall)}
                onClick={() => {
                    backModal();
                }}
            >
                <FormattedMessage
                    id="SellerApplicationAbandonConfirmation.button.cancelAndGoBack"
                    defaultMessage="Go Back"
                />
            </Button>
        </div>
    );
};

export default SellerApplicationAbandonConfirmation;
